









































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateSMSPackage from "./createsmspackage.vue";
import EditSMSPackage from "./editsmspackage.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageLogsRequest extends PageRequest {
  keyword: string;
  smsPlatform: number;
}

@Component({
  components: { CreateSMSPackage, EditSMSPackage },
})
export default class SMSPackage extends AbpBase {
  //filters
  pagerequest: PageLogsRequest = new PageLogsRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  splitnum: number = 0.01;
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  //修改
  edit() {
    this.editModalShow = true;
  }
  //新增
  create() {
    this.createModalShow = true;
  }
  //排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列表
  get list() {
    return this.$store.state.smspackage.list;
  }
  get loading() {
    return this.$store.state.smspackage.loading;
  }
  pageChange(page: number) {
    this.$store.commit("smspackage/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("smspackage/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "smspackage/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.smspackage.pageSize;
  }
  get totalCount() {
    return this.$store.state.smspackage.totalCount;
  }
  get currentPage() {
    return this.$store.state.smspackage.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      align: "left",
      title: this.L("Num"),
      key: "num",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("TotalAmmount"),
      key: "totalAmmount",
      width: 130,
      sorttable: true,
    },
    {
      align: "left",
      title: this.L("EffectiveTime"),
      key: "effectiveTime",
      width: 130,
      sorttable: true,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('smspackageDel');
        let edit = this.checkButtonAuth('smspackageEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("smspackage/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "smspackage/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
  }

  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
